<template>
  <div class="fondovista">    
    <div class="container">
      <transition name="slide-fade" appear>
        <b-card>
          <h2><b-icon-building></b-icon-building> Gestión de Colegios</h2>
          <b-card-text>
            <vue-good-table
              :columns="columns"
              :line-numbers="true"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar...'
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                nextLabel: 'Siguiente',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Filas por página',
                ofLabel: 'de',
                pageLabel: 'página', // for 'pages' mode
                allLabel: 'Todo'
              }"
              styleClass="vgt-table bordered condensed striped sm"
              :rows="rows"
            >
              <div slot="table-actions">
                <b-button size="sm" class="mr-2 ml-5">Crear Colegio</b-button>
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'nombre'">
                  <a>{{ props.row.nombre.toLowerCase() }}</a>
                </span>
              </template>
            </vue-good-table>
          </b-card-text>
        </b-card>
      </transition>
    </div>
  </div>
</template>
<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'

  export default {
    data() {
      return {
        columns: [
          { label: "Colegio", field: "nombre" },
          { label: "Id", field: "id_colegio", sortable: false },
          { label: "Municipio", field: "municipio" },
          { label: "Estado", field: "estado", sortable: false, formatFn: this.formatFn, tdClass: this.tdClassFunc }
        ],
        rows: []
      }
    },
    methods: {
      async cargarDatos() {
        await axios
        .get(CONFIG.ROOT_PATH + "colegios")
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            this.rows = response.data.datos
            //console.log(JSON.stringify(this.rows))
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
        });
      },
      formatFn: function(value) {
        return (value == 0 ? 'Inactivo' : 'Activo')
      },
      tdClassFunc(row) {
        return (row.estado == 0 ? 'text-danger' : 'text-success')
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
      }
    },
    beforeMount() {
      this.cargarDatos()
    }
  }
</script>